import React from 'react';
import LegalLayout from './LegalLayout';

export default function TermsOfService({ isDark }) {
    return (
        <LegalLayout title="Terms of Service" lastUpdated="May 28, 2026" isDark={isDark}>
            <div className="space-y-6 text-sm leading-relaxed">
                <section>
                    <h2 className="text-xl font-bold mt-8 mb-4">1. Description of Service</h2>
                    <p>Rapid DWM provides a cloud-hosted infrastructure suite, including data warehousing, automated data pipelines, and connector integrations. The Service utilizes Google Cloud Platform (GCP) to provision your dedicated database environments.</p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mt-8 mb-4">2. Account Registration and Security</h2>
                    <p>We use Google Firebase to manage identity provisioning and secure session tokens. You are responsible for safeguarding your authentication credentials. To ensure system integrity and security, the Service automatically generates immutable audit logs tracking user system IDs, email addresses, targeted actions, resource strings, and accessing IP addresses.</p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mt-8 mb-4">3. Data Privacy and Compliance (GDPR & CCPA)</h2>
                    <p>Under applicable data protection frameworks, including the GDPR and CCPA, the Customer acts as the Data Controller, and Rapid DWM acts solely as the Data Processor. You grant Rapid DWM general authorization to engage third-party sub-processors to deliver the Service.</p>
                </section>
            </div>
        </LegalLayout>
    );
}